import { useState } from "react";
import { getMemberContractsAsync } from "src/api/contract/contract-api";
import { useApiOperation } from "src/api/hooks";
import { usePartnerNavigate } from "src/api/hooks/usePartnerNavigate";
import { postWithdrawalAsync } from "src/api/member/member-api";
import { BaseButton, ConfirmModal } from "src/components";
import { BaseCheckbox } from "src/components/BaseCheckbox";
import Header from "src/components/layout/Header";
import { Modal } from "src/pages/contract/contract-types";
import { useNavigateGoBack } from "src/pages/hooks/navigate-go-back";
import usePostMessage from "src/pages/hooks/post-message";
import { useMemberInfoState } from "src/recoil/member/hook";

// 회원탈퇴 유의사항
const Withdrawal = () => {
  const [agree, setAgree] = useState(false);
  const [confirmModal, setConfirmModal] = useState<Modal>({ isOpen: false });
  const { goBack } = useNavigateGoBack();
  const navigate = usePartnerNavigate();
  const { postMessageGoMyProfileEditScreen } = usePostMessage();

  // [마이 > 프로필] 링크: 웹뷰(Taap/STPM)는 앱의 프로필 편집 화면을, 웹(TaapSpace)은 프로필 편집 페이지로 이동
  const goMyProfileEdit = () => {
    if (window.ReactNativeWebView) {
      postMessageGoMyProfileEditScreen();
    } else {
      navigate("/court/mypage/profile");
    }
  };
  const { logout } = useMemberInfoState();
  const { executeAsync: getContracts } = useApiOperation(getMemberContractsAsync);
  const { executeAsync: postWithdrawal } = useApiOperation(postWithdrawalAsync);
  const { member } = useMemberInfoState();

  const handleWithdrawal = async () => {
    if (member?.memberNo) {
      const { data: contractData, status: contractStatus } = await getContracts({
        memberNo: member?.memberNo,
        contractSteps: "APPLY_CONFIRM,CONTRACT_PLAN,CONTRACT_ACCEPT,USE_APPROVAL,USE_PROGRESS,TERMINATE_RECEIVED",
      });

      if (contractStatus >= 200 && contractStatus < 300 && contractData.data.content) {
        if (contractData.data.content && contractData.data.content.length > 0) {
          const filteredF2Contractor = contractData.data.content?.filter(
            (contract) => contract.isContractor && contract.spaceProductType === "FULL_COURT",
          );
          const filteredS2Contractor = contractData.data.content?.filter(
            (contract) => contract.isContractor && contract.spaceProductType === "TIME_COURT",
          );
          if (filteredF2Contractor.length > 0) {
            setConfirmModal({ isOpen: true, type: "F2_CONTRACT_MANAGER" });
            return;
          }
          if (filteredS2Contractor.length > 0) {
            setConfirmModal({ isOpen: true, type: "S2_CONTRACT_MANAGER" });
            return;
          }
          navigate("/court/mypage/profile/withdrawalReservation");
        } else {
          const { status } = await postWithdrawal();
          if (status >= 200 && status < 300) {
            logout();
            navigate("/court/mypage/profile/withdrawalComplete");
          }
        }
      }
    }
  };
  return (
    <div className="withdrawal-page">
      <Header headerType="BACK" />
      <div className="base-detail-layout">
        <h2>정말 탈퇴하시겠습니까?</h2>
        <div className="withdrawal-notice">
          <p className="withdrawal-notice__title">
            회원탈퇴 즉시 서비스 이용이 불가하며, <br />
            계정 정보 및 이용내역은 복구할 수 없습니다
          </p>
          <p className="withdrawal-notice__sub">
            닉네임, 이메일, 휴대폰번호는 탈퇴 없이 <b onClick={goMyProfileEdit}>[마이 &gt; 프로필]</b>에서 수정할 수 있습니다.
          </p>
        </div>

        <BaseCheckbox
          id={"agree"}
          name={"agree"}
          checked={agree}
          className="flex-center"
          onChange={() => {
            setAgree((prev) => !prev);
          }}
        >
          <p className="ml10 font16 font-weight-600">[필수] 유의사항을 확인하였으며, 회원탈퇴에 동의합니다</p>
        </BaseCheckbox>
      </div>
      {confirmModal.isOpen && (
        <ConfirmModal
          isOpen={true}
          btnRightTitle={"확인"}
          onClick={() => {
            setConfirmModal({ isOpen: false });
          }}
        >
          <h2 className="font18 font-weight-600">
            {confirmModal.type === "S2_CONTRACT_MANAGER" ? "유효한 공간 예약이 있습니다" : "계약담당자는 탈퇴할 수 없습니다"}
          </h2>
          <p className="mt20 font15">
            {confirmModal.type === "S2_CONTRACT_MANAGER"
              ? "예약을 취소하거나 예약이 종료된 후 다시 시도해주세요"
              : "건물 관리소 또는 공간 운영자에게 문의하세요"}
          </p>
        </ConfirmModal>
      )}

      <div className="btn-wrap">
        <BaseButton title="취소" className="base-btn color-white" onClick={() => goBack()}></BaseButton>
        <BaseButton title="회원 탈퇴하기" className="base-btn" disabled={!agree} onClick={handleWithdrawal}></BaseButton>
      </div>
    </div>
  );
};

export default Withdrawal;
